import { GridColDef } from "@mui/x-data-grid";
import { StyledTable } from "../../../../components/table/styled-table";
import { GetOrdersDetailsPayloadResponse } from "../../../../services/orders/orders-details-get-by-id/types";
import {
  dateFormating,
  getPlaceEnum,
  getPurposeFromEnum,
  getStatusFromEnum,
  getTemperatureConditionsEnum,
  getTypeFromEnum,
} from "../helpers";
import { useEffect } from "react";

interface OfferingOrderDetailsTableProps {
  ordersDetails: GetOrdersDetailsPayloadResponse[];
}
const OfferingOrderDetailsTable = ({
  ordersDetails,
}: OfferingOrderDetailsTableProps) => {
  const columns: GridColDef[] = [
    {
      field: "numer_zamowienia",
      headerName: "Numer zamówienia",
      width: 200,
      hideable: false,
    },
    { field: "status_zamowienia", headerName: "Status", width: 200 },
    { field: "klient", headerName: "Klient", width: 200 },
    { field: "kontakt", headerName: "Kontakt", width: 200 },
    { field: "uslugi_zamowione", headerName: "Cel zamówienia", width: 150 },
    { field: "rodzaj_towaru", headerName: "Rodzaj towaru", width: 150 },
    {
      field: "termin_rozpoczecia",
      headerName: "Termin rozpoczęcia",
      width: 200,
    },
    {
      field: "termin_zakonczenia",
      headerName: "Termin zakończenia",
      width: 200,
    },
    {
      field: "miejsce",
      headerName: "Miejsce",
      width: 150,
    },
    {
      field: "warunek_temp",
      headerName: "Warunek temp.",
      width: 200,
    },
  ];
  const rows = ordersDetails.map((r) => ({
    id: r.id_zamowienie,
    numer_zamowienia: r.numer_zamowienia,
    status_zamowienia: getStatusFromEnum(r.status_zamowienia),
    klient: r.klient?.nazwa,
    kontakt: r.klient.telefon,
    uslugi_zamowione: getPurposeFromEnum(r.uslugi_zamowione?.cel_zamowienia),
    rodzaj_towaru: getTypeFromEnum(r.rodzaj_towaru),
    termin_rozpoczecia: dateFormating(r.termin_rozpoczecia),
    termin_zakonczenia: dateFormating(r.termin_zakonczenia),
    miejsce: getPlaceEnum(r.miejsce),
    warunek_temp: getTemperatureConditionsEnum(r.warunek_temperaturowy),
  }));
  return (
    <StyledTable
      getRowId={(row:any) => row?.id}
      rows={rows}
      columns={columns}
      hideFooter={true}
      pageSize={1}
      disableSelectionOnClick={true}
      autoHeight
    />
  );
};

export default OfferingOrderDetailsTable;
